import React from 'react'

interface NavItemProps {
  glyph: string
  navText: string
}

export const NavItem: React.FC<NavItemProps> = ({ glyph, navText }) => (
  <div className="display-flex align-items-center">
    <span className={`cb-glyph ${glyph} cb-margin-right-4`}></span>
    <span>{navText}</span>
  </div>
)
